import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4e3da5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-themes card-outline card-outline-tabs" }
const _hoisted_5 = { class: "card-header p-0 border-bottom-0" }
const _hoisted_6 = { class: "nav nav-tabs" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "card-body no-padding row" }
const _hoisted_10 = { class: "tab-content col-lg-7" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pb-0\" data-v-6d4e3da5><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input101\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>数据显示行数</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"email\" class=\"form-control\" id=\"input101\" placeholder=\"Name\" data-v-6d4e3da5></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input102\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Email</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"email\" class=\"form-control\" id=\"input102\" placeholder=\"Email\" data-v-6d4e3da5></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input103\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Name</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"text\" class=\"form-control\" id=\"input103\" placeholder=\"Name\" data-v-6d4e3da5></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input104\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Experience</label><div class=\"col-md-10\" data-v-6d4e3da5><textarea class=\"form-control\" id=\"input104\" placeholder=\"Experience\" data-v-6d4e3da5></textarea></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input105\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Skills</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"text\" class=\"form-control\" id=\"input105\" placeholder=\"Skills\" data-v-6d4e3da5></div></div></div>", 1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pb-0\" data-v-6d4e3da5><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input201\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>系统标题</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"email\" class=\"form-control\" id=\"input201\" placeholder=\"Name\" data-v-6d4e3da5></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input202\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Email</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"email\" class=\"form-control\" id=\"input202\" placeholder=\"Email\" data-v-6d4e3da5></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input203\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Name</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"text\" class=\"form-control\" id=\"input203\" placeholder=\"Name\" data-v-6d4e3da5></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input204\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Experience</label><div class=\"col-md-10\" data-v-6d4e3da5><textarea class=\"form-control\" id=\"input204\" placeholder=\"Experience\" data-v-6d4e3da5></textarea></div></div><div class=\"form-group row\" data-v-6d4e3da5><label for=\"input205\" class=\"col-md-2 col-form-label\" data-v-6d4e3da5>Skills</label><div class=\"col-md-10\" data-v-6d4e3da5><input type=\"text\" class=\"form-control\" id=\"input205\" placeholder=\"Skills\" data-v-6d4e3da5></div></div></div>", 1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "card-footer" }
const _hoisted_16 = { class: "tab-content row" }
const _hoisted_17 = { class: "col-md-6 text-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 重置 ")

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link text-themes", {'active' : _ctx.activeTab === 'COMMON'}]),
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.setActiveTab('COMMON')))
                }, "常规", 2)
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link text-themes", {'active' : _ctx.activeTab === 'ADVANCED'}]),
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.setActiveTab('ADVANCED')))
                }, "高级", 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'COMMON'}])
              }, _hoisted_12, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'ADVANCED'}])
              }, _hoisted_14, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_app_button, { class: "btn btn-themes" }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_app_button, { class: "btn btn-themes ml-4" }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}